import Graphic from "../Assets/Graphic.svg";
import Mobile from "../Assets/Mobile.svg";
import Web from "../Assets/Web.svg";
import Desktop from "../Assets/Desktop.svg";
import React, { useEffect } from "react";
import AOS from "aos";

function Services(props) {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <div>
      <section className="services" id="Services">
        <section className="cards">
          <section className="card" data-aos="zoom-in">
            <div className="header">
              <embed src={Web} type="" /> <h3>Web App</h3>
            </div>
            <p>
            Web applications provide a number of advantages over traditional desktop applications. A web application is accessible anywhere at anytime. You don't have to install any software on your computer before accessing the application. You can access them from any device connected to the internet.
            </p>
          </section>

          <section className="card2" data-aos="fade-up">
            <div className="header">
              <embed src={Desktop} type="" /> <h3>Desktop App</h3>
            </div>
            <p>
            Desktop applications are software programs that run on computers. They are often referred to as apps. Apps are designed to work on desktops, laptops, tablets, smartphones, and other devices. Desktop applications are typically used for personal use, business use, education, and entertainment.
            </p>
          </section>

          <section className="card3" data-aos="flip-right">
            <div className="header">
              <embed src={Mobile} type="" /> <h3>Mobile App</h3>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores
              ab nostrum vitae eum nesciunt minus minima sapiente numquam
              quidem, distinctio esse, nulla reiciendis nisi. Fuga
            </p>
          </section>

          <section className="card4" data-aos="fade-down-right">
            <div className="header">
              <embed src={Graphic} type="" /> <h3>Graphic Design</h3>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores
              ab nostrum vitae eum nesciunt minus minima sapiente numquam
              quidem, distinctio esse, nulla reiciendis nisi. Fuga
            </p>
          </section>
        </section>

        <section className="what" data-aos="fade-down">
          <div className="headers">
            <hr className="hrs" /> WHAT I DO
          </div>
          <h3>
            Better Design <br /> Better Experiences
          </h3>
          <p>
          User experience design (UXD) is the practice of designing products and services that people use. UXD focuses on how users interact with a product or service and includes the visual aspects, functionality, and usability of the interface.
          </p>
        </section>
      </section>
    </div>
  );
}

export default Services;
